export var Locale;
(function (Locale) {
    Locale["af"] = "af";
    Locale["ak"] = "ak";
    Locale["am"] = "am";
    Locale["ar"] = "ar";
    Locale["az"] = "az";
    Locale["be"] = "be";
    Locale["bg"] = "bg";
    Locale["bn"] = "bn";
    Locale["bo"] = "bo";
    Locale["bs-BA"] = "bs_BA";
    Locale["ca"] = "ca";
    Locale["ceb"] = "ceb";
    Locale["ch"] = "ch";
    Locale["cs"] = "cs";
    Locale["cy-GB"] = "cy_GB";
    Locale["da"] = "da";
    Locale["de"] = "de";
    Locale["el"] = "el";
    Locale["en-test"] = "en-test";
    Locale["en"] = "en";
    Locale["es"] = "es";
    Locale["et"] = "et";
    Locale["eu-ES"] = "eu_ES";
    Locale["fa"] = "fa";
    Locale["fi"] = "fi";
    Locale["fil"] = "fil";
    Locale["fj"] = "fj";
    Locale["fo-FO"] = "fo_FO";
    Locale["fr"] = "fr";
    Locale["fr-GA"] = "fr_GA";
    Locale["ga-IE"] = "ga_IE";
    Locale["gd"] = "gd";
    Locale["gl-ES"] = "gl_ES";
    Locale["gsw"] = "gsw";
    Locale["gu-IN"] = "gu_IN";
    Locale["guz"] = "guz";
    Locale["ha"] = "ha";
    Locale["haw"] = "haw";
    Locale["he"] = "he";
    Locale["hi"] = "hi";
    Locale["hr"] = "hr";
    Locale["ht-HT"] = "ht_HT";
    Locale["hu"] = "hu";
    Locale["hy"] = "hy";
    Locale["id"] = "id";
    Locale["ig"] = "ig";
    Locale["is"] = "is";
    Locale["it"] = "it";
    Locale["ja"] = "ja";
    Locale["jv"] = "jv";
    Locale["ka-GE"] = "ka_GE";
    Locale["ki"] = "ki";
    Locale["kk"] = "kk";
    Locale["km-KH"] = "km_KH";
    Locale["kn-IN"] = "kn_IN";
    Locale["ko"] = "ko";
    Locale["lb"] = "lb";
    Locale["lo"] = "lo";
    Locale["lt"] = "lt";
    Locale["luo"] = "luo";
    Locale["lv"] = "lv";
    Locale["mi-NZ"] = "mi_NZ";
    Locale["mk-MK"] = "mk_MK";
    Locale["ml-IN"] = "ml_IN";
    Locale["mn-MN"] = "mn_MN";
    Locale["mr"] = "mr";
    Locale["ms"] = "ms";
    Locale["mt-MT"] = "mt_MT";
    Locale["my"] = "my";
    Locale["ne"] = "ne";
    Locale["nl"] = "nl";
    Locale["no"] = "no";
    Locale["nus"] = "nus";
    Locale["or-IN"] = "or_IN";
    Locale["pa"] = "pa";
    Locale["pl"] = "pl";
    Locale["ps-AF"] = "ps_AF";
    Locale["pt"] = "pt";
    Locale["ro"] = "ro";
    Locale["ru"] = "ru";
    Locale["sd"] = "sd";
    Locale["si"] = "si";
    Locale["sk"] = "sk";
    Locale["sl"] = "sl";
    Locale["so"] = "so";
    Locale["sq"] = "sq";
    Locale["sr"] = "sr";
    Locale["su"] = "su";
    Locale["sv"] = "sv";
    Locale["sw"] = "sw";
    Locale["ta"] = "ta";
    Locale["te-IN"] = "te_IN";
    Locale["th"] = "th";
    Locale["ti"] = "ti";
    Locale["tl"] = "tl";
    Locale["to"] = "to";
    Locale["tr"] = "tr";
    Locale["uk"] = "uk";
    Locale["ur"] = "ur";
    Locale["uz"] = "uz";
    Locale["vi"] = "vi";
    Locale["xh"] = "xh";
    Locale["yo"] = "yo";
    Locale["zh-CN"] = "zh_CN";
    Locale["zh-TW"] = "zh_TW";
    Locale["zu"] = "zu";
    Locale["test"] = "test";
})(Locale || (Locale = {}));
export const DEFAULT_LOCALE = Locale.en;
export var SupportedCurrency;
(function (SupportedCurrency) {
    SupportedCurrency["usd"] = "USD";
    SupportedCurrency["aud"] = "AUD";
    SupportedCurrency["cad"] = "CAD";
    SupportedCurrency["eur"] = "EUR";
    SupportedCurrency["gbp"] = "GBP";
    SupportedCurrency["inr"] = "INR";
    SupportedCurrency["mxn"] = "MXN";
    SupportedCurrency["nzd"] = "NZD";
    SupportedCurrency["php"] = "PHP";
    SupportedCurrency["brl"] = "BRL";
})(SupportedCurrency || (SupportedCurrency = {}));
export const PROVIDER_TITLES = [
    'Dr.',
    'Mr.',
    'Mrs.',
    'Miss',
    'Ms.',
    'Mx.',
    'Other',
];
